
import React from 'react';
import { SearchIcon } from './icons';
import { t } from '../translations';
import { Language } from '../types';

interface NoResultsProps {
    onClear: () => void;
    language: Language;
    onSuggest?: (query: string) => void;
}

/** Популярные запросы — подсказка гостю если поиск пуст. */
const SUGGESTIONS_BY_LANG: Record<Language, string[]> = {
    ru: ['Манты', 'Лагман', 'Плов', 'Шорпо', 'Куурдак'],
    ky: ['Манты', 'Лагман', 'Палоо', 'Шорпо', 'Куурдак'],
    en: ['Manti', 'Lagman', 'Plov', 'Shorpo', 'Kuurdak'],
    zh: ['肉饺子', '拉面', '抓饭', '羊肉汤', '库尔达克'],
};

const NoResults: React.FC<NoResultsProps> = ({ onClear, language, onSuggest }) => {
    const suggestions = SUGGESTIONS_BY_LANG[language] || SUGGESTIONS_BY_LANG.ru;

    return (
        <div className="text-center py-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[var(--neutral-bg)] rounded-full mb-4">
                <SearchIcon className="w-8 h-8 text-[var(--text-secondary)]" />
            </div>
            <p className="text-xl font-semibold text-[var(--text-primary)]">{t('noResults.title', language)}</p>
            <p className="text-[var(--text-secondary)] mt-2 mb-6">{t('noResults.subtitle', language)}</p>

            {onSuggest && (
                <div className="mb-6">
                    <p className="text-xs font-bold text-[var(--text-secondary)] uppercase tracking-widest mb-3">
                        {t('noResults.tryThese', language)}
                    </p>
                    <div className="flex flex-wrap justify-center gap-2 px-4">
                        {suggestions.map((q) => (
                            <button
                                key={q}
                                onClick={() => onSuggest(q)}
                                className="px-3 py-1.5 rounded-full bg-[var(--neutral-bg)] hover:bg-[var(--neutral-bg-hover)] text-sm font-medium text-[var(--text-primary)] transition-colors"
                            >
                                {q}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            <button
                onClick={onClear}
                className="px-5 py-2 bg-[var(--accent-color)] text-[var(--accent-text)] font-semibold rounded-lg shadow hover:opacity-90 transition-opacity"
            >
                {t('noResults.button', language)}
            </button>
        </div>
    );
};

export default NoResults;
